import { NavLink, Link, Outlet, useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import { useTheme } from '../lib/theme';
import { Logo } from './Logo';
import { Icon } from './ui';

export function AppShell() {
  const { me, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const navigate = useNavigate();
  const isAdmin = me?.role === 'admin';

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar__inner">
          <Link to="/" className="topbar__brand" aria-label="Pixerito Social, início">
            <Logo variant="horizontal" />
            <span className="topbar__product">Social</span>
          </Link>

          <nav className="topbar__nav" aria-label="Principal">
            {isAdmin ? (
              <NavLink to="/admin" end={false}>
                Clientes
              </NavLink>
            ) : (
              <>
                <NavLink to="/painel" end>
                  Resultados
                </NavLink>
                <NavLink to="/painel/entregaveis">Entregáveis</NavLink>
              </>
            )}
          </nav>

          <div className="topbar__user">
            <div className="topbar__who">
              <b>{me?.name}</b>
              <span>{isAdmin ? 'Admin' : me?.clientName}</span>
            </div>
            <Link to="/conta" className="icon-btn" aria-label="Minha conta" title="Minha conta">
              <Icon name="user" />
            </Link>
            <button
              className="icon-btn"
              onClick={toggle}
              aria-label={theme === 'dark' ? 'Usar tema claro' : 'Usar tema escuro'}
              title={theme === 'dark' ? 'Tema claro' : 'Tema escuro'}
            >
              <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
            </button>
            <button
              className="icon-btn"
              aria-label="Sair"
              title="Sair"
              onClick={() => {
                logout();
                navigate('/login');
              }}
            >
              <Icon name="logout" />
            </button>
          </div>
        </div>
      </header>
      <main className="page" id="conteudo">
        <Outlet />
      </main>
    </div>
  );
}
